import './index.css';
import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { useTimer } from './useTimer.js';

var styles = {"timer":"magritte-timer___W-ykJ_1-2-45","timer-circle":"magritte-timer-circle___awHNF_1-2-45","timerCircle":"magritte-timer-circle___awHNF_1-2-45"};

const SVG_CIRCLE_RADIUS = 9.19;
const SVG_CIRCLE_LENGTH = 2 * Math.PI * SVG_CIRCLE_RADIUS;
const Timer = ({ timeout, pause = false, callback }) => {
    const svgRef = useRef(null);
    const circleRef = useRef(null);
    useTimer(timeout, (_callable) => {
        const timerId = requestAnimationFrame(_callable);
        return () => {
            cancelAnimationFrame(timerId);
        };
    }, (remaining) => {
        if (svgRef.current) {
            svgRef.current.setAttribute('aria-valuenow', `${Math.round((1 - remaining) * SVG_CIRCLE_LENGTH)}`);
        }
        if (circleRef.current) {
            circleRef.current.setAttribute('stroke-dashoffset', `${remaining * SVG_CIRCLE_LENGTH}`);
        }
        if (remaining < 0) {
            callback?.();
        }
    }, pause);
    if (!timeout) {
        return null;
    }
    return (jsx("svg", { className: styles.timer, "aria-valuemin": 0, "aria-valuemax": Math.round(SVG_CIRCLE_LENGTH), role: "progressbar", width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", ref: svgRef, children: jsx("circle", { className: styles['timer-circle'], r: SVG_CIRCLE_RADIUS, cx: "12", cy: "12", fill: "none", strokeDasharray: SVG_CIRCLE_LENGTH, strokeLinecap: "round", strokeWidth: "2.625", transform: "rotate(-90,12,12)", ref: circleRef }) }));
};

export { Timer };
//# sourceMappingURL=Timer.js.map
